export const D38_22_23 = {
    "selectedValueColumn": "AgentCustomerGroupDistributorCustomer",
    "selectedTitle": "Product",
    "visuals": [
        {
            "title": "PESO",
            "visual": [
                {
                    "columns": 12,
                    "rows": 2,
                    "visual": {
                        "id": 1,
                        "type": "advancedTable",
                        "colorTheme": 'colorTheme1',
                        "title": "Product Growth",
                        "binding": {
                            "data": {
                                "columns": [
                                    {
                                        "name": 'Product Name',
                                        "columnName": 'ItemName',
                                        "width": '500px',
                                        "align": "left",
                                        "sortable": true,
                                        "sum": false,
                                    },
                                    {
                                        "name": 'Actual Sales',
                                        "columnName": 'ActualSales',
                                        "width": '140px',
                                        "align": "right",
                                        "sortable": true,
                                        "sum": true,
                                    },
                                    {
                                        "name": 'LY Sales',
                                        "columnName": 'LYSales',
                                        "width": '125px',
                                        "align": "right",
                                        "sortable": true,
                                        "sum": true,
                                    },
                                    {
                                        "name": 'Growth %',
                                        "columnName": 'Growth',
                                        "width": '125px',
                                        "align": "right",
                                        "sortable": true,
                                        "sum": false,
                                        "percent": true
                                    }
                                ],
                                "title": "ItemName",
                                "endpoint": "D38.22",
                                "parameters": [
                                    { "key": "FromMonth", "value": "2024" },
                                    { "key": "FromYear", "value": "1" },
                                    { "key": "ToMonth", "value": "2024" },
                                    { "key": "ToYear", "value": "1" },
                                    { "key": "AgentCustomerGroupDistributorCustomer", "value": "" },
                                    { "key": "ConfigTypeCode", "value": "" },
                                    { "key": "DistrictManagerCode", "value": "" }
                                ]
                            },
                            "context": {
                                "point": {
                                    "onClick": {

                                    }
                                }
                            }
                        }
                    }
                }
            ]
        },
        {
            "title": "UNIT",
            "visual": [
                {
                    "columns": 12,
                    "rows": 2,
                    "visual": {
                        "id": 1,
                        "type": "advancedTable",
                        "colorTheme": 'colorTheme1',
                        "title": "Product Growth",
                        "binding": {
                            "data": {
                                "columns": [
                                    {
                                        "name": 'Product Name',
                                        "columnName": 'ItemName',
                                        "width": '500px',
                                        "align": "left",
                                        "sortable": true,
                                        "sum": false,
                                    },
                                    {
                                        "name": 'Actual Sales',
                                        "columnName": 'ActualSales',
                                        "width": '140px',
                                        "align": "right",
                                        "sortable": true,
                                        "sum": true,
                                    },
                                    {
                                        "name": 'LY Sales',
                                        "columnName": 'LYSales',
                                        "width": '125px',
                                        "align": "right",
                                        "sortable": true,
                                        "sum": true,
                                    },
                                    {
                                        "name": 'Growth %',
                                        "columnName": 'Growth',
                                        "width": '125px',
                                        "align": "right",
                                        "sortable": true,
                                        "sum": false,
                                        "percent": true
                                    }
                                ],
                                "title": "ItemName",
                                "endpoint": "D38.23",
                                "parameters": [
                                    { "key": "FromMonth", "value": "2024" },
                                    { "key": "FromYear", "value": "1" },
                                    { "key": "ToMonth", "value": "2024" },
                                    { "key": "ToYear", "value": "1" },
                                    { "key": "AgentCustomerGroupDistributorCustomer", "value": "" },
                                    { "key": "ConfigTypeCode", "value": "" },
                                    { "key": "DistrictManagerCode", "value": "" }
                                ]
                            },
                            "context": {
                                "point": {
                                    "onClick": {

                                    }
                                }
                            }
                        }
                    }
                }
            ]
        }
    ]
}